import React from 'react';
import { useTheme } from '@mui/material';
import DSBox from '../../../design-system/DSBox';
import DSDialog from '../../../design-system/DSDialog';
import DSDialogTitle from '../../../design-system/DSDialogTitle';
import DSDialogContent from '../../../design-system/DSDialogContent';
import DSDialogActions from '../../../design-system/DSDialogActions';
import DSTextField from '../../../design-system/DSTextField';
import DSSecondaryButton from '../../../design-system/DSSecondaryButton';
import { DSTypography } from '../../../design-system/Typography';
import { REVIEW_COMMENT_LIMIT } from '../../../consts/textFieldsLimitations';

type CollectionReviewDialogProps = {
  reviewMessage: string;
  comment: string;
  onCommentChange: (comment: string) => void;
  onClose: () => void;
};

/**
 * The heading claims a verdict only while the record still carries one — editing
 * pulls a collection back to `draft`. The reply is autosaved like every other
 * field, so the dialog only reads and writes it.
 */
const CollectionReviewDialog: React.FC<CollectionReviewDialogProps> = ({
  reviewMessage,
  comment,
  onCommentChange,
  onClose,
}) => {
  const { spacing, palette } = useTheme();

  return (
    <DSDialog open onClose={onClose} fullWidth maxWidth="xs">
      <DSDialogTitle sx={{ color: palette.text.primary }}>
        Review message
      </DSDialogTitle>
      <DSDialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: spacing(2) }}
      >
        <DSBox
          sx={{
            background: palette.secondary.main,
            borderRadius: spacing(2),
            padding: spacing(2),
          }}
        >
          <DSTypography variant="label" fontSize={12}>
            Reviewer note
          </DSTypography>
          <DSTypography
            variant="body1"
            fontSize={14}
            color={palette.text.primary}
          >
            {reviewMessage}
          </DSTypography>
        </DSBox>
        <DSTextField
          autoFocus
          fullWidth
          multiline
          minRows={2}
          placeholder="Add a comment for the reviewer..."
          value={comment}
          slotProps={{
            input: {
              inputProps: { maxLength: REVIEW_COMMENT_LIMIT },
            },
          }}
          onChange={(event) => onCommentChange(event.target.value)}
        />
        <DSTypography variant="body1" fontSize={12} alignSelf="flex-end">
          {comment.length}/{REVIEW_COMMENT_LIMIT}
        </DSTypography>
      </DSDialogContent>
      <DSDialogActions>
        <DSSecondaryButton onClick={onClose}>Close</DSSecondaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default CollectionReviewDialog;
